import React, { useEffect, useState } from "react";
import { makeGetRequest } from "../../../../utils/api";
import { urls } from "../../../../utils/urls";
import Card from "react-bootstrap/esm/Card";
import Col from "react-bootstrap/esm/Col";
import Row from "react-bootstrap/esm/Row";
import Button from "react-bootstrap/esm/Button";
import toast, { Toaster } from "react-hot-toast";
import BackToGameList from "../../utils/BackToGameList";

function ShoppingList() {
  const [items, setItems] = useState([]);
  const [shoppingItems, setShoppingItems] = useState([]);
  const [store, setStore] = useState(false);
  const [returnedHome, setReturnedHome] = useState(false);
  const [cart, setCart] = useState([]);
  const [correct, setCorrect] = useState(false);
  const [correctAmount, setCorrectAmount] = useState(0);
  const [difficulty, setDifficulty] = useState(9);
  const [difficultyItem, setDifficultyItem] = useState(3);
  const [score, setScore] = useState(0);
  const [toolTip, setToolTip] = useState('');
  const [level, setLevel] = useState(1);
  
  const handleItems = async () => {
    let rnd1 = 0;
    let rnd2 = 0;
    let rnd3 = 0;
    let rnd4 = 0;
    let rnd5 = 0;
    let rnd6 = 0;
    let rnd7 = 0;
    let rnd8 = 0;
    let rnd9 = 0;
    let rndA = [];
    let dup = "";
    let count = 0
    let rndItemRemoval = 0
    const response = await makeGetRequest(
      urls.getIcons + "?active=True&category=0",
      "",
      true
    );
    do {
      rndItemRemoval = Math.floor(Math.random * response.data.legth + 1)
      response.data.pop(rndItemRemoval)
      count = count + 1
    } while (response.data.length > difficulty)
    setItems(response.data);
    do {
      rnd1 = Math.floor(Math.random() * response.data.length);
      rnd2 = Math.floor(Math.random() * response.data.length);
      rnd3 = Math.floor(Math.random() * response.data.length);
      rnd4 = Math.floor(Math.random() * response.data.length);
      rnd5 = Math.floor(Math.random() * response.data.length);
      rnd6 = Math.floor(Math.random() * response.data.length);
      rnd7 = Math.floor(Math.random() * response.data.length);
      rnd8 = Math.floor(Math.random() * response.data.length);
      rnd9 = Math.floor(Math.random() * response.data.length);
      rndA = [rnd1, rnd2, rnd3, rnd4, rnd5, rnd6, rnd7, rnd8, rnd9];
      dup = findDuplicateValues(rndA);
    } while (dup === 1);
    let shoppingItems = [
      {
        id: response.data[rnd1].id,
        item: response.data[rnd1].item,
        image: response.data[rnd1].image,
      },
      {
        id: response.data[rnd2].id,
        item: response.data[rnd2].item,
        image: response.data[rnd2].image,
      },
      {
        id: response.data[rnd3].id,
        item: response.data[rnd3].item,
        image: response.data[rnd3].image,
      },
      {
        id: response.data[rnd4].id,
        item: response.data[rnd4].item,
        image: response.data[rnd4].image,
      },
      {
        id: response.data[rnd5].id,
        item: response.data[rnd5].item,
        image: response.data[rnd5].image,
      },
      {
        id: response.data[rnd6].id,
        item: response.data[rnd6].item,
        image: response.data[rnd6].image,
      },
      {
        id: response.data[rnd7].id,
        item: response.data[rnd7].item,
        image: response.data[rnd7].image,
      },
      {
        id: response.data[rnd8].id,
        item: response.data[rnd8].item,
        image: response.data[rnd8].image,
      },
      {
        id: response.data[rnd9].id,
        item: response.data[rnd9].item,
        image: response.data[rnd9].image,
      },
    ]
    if(difficultyItem < 9){
      do {
        rndItemRemoval = Math.floor(Math.random * response.data.legth + 1)
        shoppingItems.pop(rndItemRemoval)
        count = count + 1}
        while (shoppingItems.length > difficultyItem)
    }
    setShoppingItems(shoppingItems);
  };

  const findDuplicateValues = (array) => {
    let sortedArray = array.slice().sort();
    let dupFound = 0;
    for (let i = 0; i < sortedArray.length; i++) {
      if (sortedArray[i] === sortedArray[i + 1]) {
        dupFound = 1;
      }
    }
    return dupFound;
  };

  const goToTheStore = () => {
    setStore(true);
  };

  const shoppingCart = (item) => {
    if (cart.findIndex((cartItem) => cartItem.id === item.id) === -1) {
      setCart((prevItems) => [
        ...prevItems,
        {
          id: item.id,
          item: item.item,
          image: item.image,
        },
      ]);
      toast(item.item + " has been added to your cart!", {
        duration: 5000,
        position: "right",
      });
    } else {
      toast(item.item + " is already in your cart.", {
        duration: 5000,
        position: "right",
      });
    }
  };

  const removeFromCart = (item) => {
    let newCart = cart.filter((cartItems) => cartItems.id !== item.id);
    setCart(newCart);
  };

  const checkOut = () => {
    let cartItemsTest = cart.map((cartItems) => {
      for (let i = 0; i < shoppingItems.length; i++) {
        if (shoppingItems[i].id === cartItems.id) {
          setCorrectAmount((prevAmount) => prevAmount + 1);
          return true;
        }
      }
    });
    let cartItemsCorrect = false;
    if (cartItemsTest.includes(undefined)) {
    } else {
      cartItemsCorrect = true;
    }
    if (cartItemsCorrect === true && cart.length === (difficultyItem)) {
      setCorrect(true);
    }
    setStore(false);
    setReturnedHome(true);
  };

  useEffect(() => {
    if (shoppingItems.length === 0) {
      handleItems();
    }
  }, [level]);

  const restartGame = () => {
    setCart([]);
    setShoppingItems([]);
    setCorrectAmount(0);
    setReturnedHome(false);
    setCorrect(false);
    setScore((Math.floor(difficulty/2) * (difficultyItem * 2) * 100) + score)
    let dif = Math.floor(Math.random() * 10)
    if(dif >= 5){
      if(difficulty < 36){
        setToolTip('The number of items in the store increased!')
        setDifficulty(difficulty + 3)
      }
    }else{
      if(difficultyItem < 9){
        setToolTip('The number of items you need to remember increased!')
        setDifficultyItem(difficultyItem + 1)
      }
    }
    setLevel(level + 1)
  };

  const tryAgain = () => {
    setCorrectAmount(0);
    setReturnedHome(false);
    setCorrect(false);
    setStore(true);
  };
  return (
    <>
      <BackToGameList />
      <Card
        style={{
          width: "80%",
          marginLeft: "auto",
          marginRight: "auto",
          marginTop: "50px",
        }}
      >
        <Card.Header style={{textAlign:'right',fontSize:'30px'}}>Score: {score}</Card.Header>
        <Card.Body>
          {!store ? (
            <>
              <Row>
                <h4 style={{ textAlign: "center" }}>
                  {correct ? (
                    <h2>You've completed level {level}!</h2>
                  ) : correctAmount > 0 ? (
                    <h2>The Items to Bring back on the Next Trip: </h2>
                  ) : (
                    <h2>Remember these Items:</h2>
                  )}
                </h4>
              </Row>
              <Row>
                {shoppingItems.map((item) => {
                  return (
                    <Col key={item.item} style={{ textAlign: "center" }}>
                      <img
                        key={item.item}
                        style={{ width: "128px", height: "128px" }}
                        src={item.image}
                      />
                    </Col>
                  );
                })}
              </Row>
              {!returnedHome ? (
                <>
                  <Row style={{ margin: "25px" }}>
                    <h1 style={{ textAlign: "center" }}>
                      When you are ready to proceed, press go to the store! <br /><br />
                      <div style={{color:'green'}}>{level > 1 && 'Level ' + level + ': ' + toolTip}</div>
                    </h1>
                  </Row>
                  <Row>
                    <Button onClick={() => goToTheStore()} style={{fontSize:'30px', height:"100px"}}>
                      Go To The Store
                    </Button>
                  </Row>
                </>
              ) : (
                <Row style={{ borderTop: "1px solid #ccc", paddingTop: "20px", marginTop: "20px" }}>
                  <Row>
                    <h2 style={{ textAlign: "center" }}>
                      These are the items that you got at the grocery store:
                    </h2>
                  </Row>
                  <Row>
                    {cart.map((item) => {
                      return (
                        <Col key={item.item} style={{ textAlign: "center" }}>
                          <img
                            key={item.item}
                            style={{ width: "128px", height: "128px" }}
                            src={item.image}
                          />
                        </Col>
                      );
                    })}
                  </Row>
                  <Row>
                    {correct ? (
                      <Col style={{ margin: "25px", textAlign: "center" }}>
                        <h3>
                          Looks like you got all the items that you needed from
                          the store! Good job! To increase the difficulty and play again select the "Next Level"
                          button below. To start from the beginning again, select "Restart Game"
                        </h3>
                            <Col>
                              <Button onClick={() => restartGame()} style={{marginBottom:'15px',fontSize:'30px'}} variant="success">
                                Next Level ({level + 1})
                              </Button>
                            </Col>
                            <Col>
                              <Button onClick={() => window.location.reload()} variant="warning">
                                Restart Game
                              </Button>
                            </Col>
                      </Col>
                    ) : (
                      <>
                        <h2 style={{ marginTop: "50px" }}>
                          {difficultyItem < (cart.length)
                            ? `Looks like you got all the items that you needed from the store and then some more! You got a total of ` +
                              cart.length +
                              ` items from the store when you only needed ` + (difficultyItem) + `. Would
                              you like to go back to the store and try again? If so,
                              press the Back To The Store button, if you want to try
                              with different items press Restart Game.`
                            : `Looks like you didn't get all the items that you needed
                        from the store. You got ` +
                              correctAmount +
                              ` out of `+ (difficultyItem) + ` correct. Would
                        you like to go back to the store and try again? If so,
                        press the Back To The Store button, if you want to try
                        with different items press Restart Game.`}
                        </h2>
                        <Row>
                          <div style={{ textAlign: "center" }}>
                            <Col>
                              <Col>
                                <Button
                                  style={{ marginBottom: "15px", fontSize:'30px' }}
                                  onClick={() => tryAgain()}
                                  variant="info"
                                >
                                  Back To The Store
                                </Button>
                              </Col>
                              <Button onClick={() => window.location.reload()} variant="warning">
                                Restart Game
                              </Button>
                            </Col>
                          </div>
                        </Row>
                      </>
                    )}
                  </Row>
                </Row>
              )}
            </>
          ) : (
            <>
              <Row>
                <h1>Items in the store:</h1>
                {items.map((item) => {
                  return (
                    <Col
                      key={item.item}
                      style={{ textAlign: "center"}}
                    >
                      <Button
                        className="green-hover"
                        onClick={() => shoppingCart(item)}
                        style={{ margin: "5px" }}
                        variant="secondary"
                      >
                        <img
                          key={item.item}
                          style={{ width: "128px", height: "128px" }}
                          src={item.image}
                        />
                      </Button>
                    </Col>
                  );
                })}
              </Row>
              <Row style={{ borderTop: "1px solid #ccc", paddingTop: "20px" }}>
                <Row style={{ marginTop: "20px" }}>
                  <h2>Current Items in your Cart 🛒:</h2>
                </Row>
                <div style={{ borderRadius: "20px" }}>
                  <Row>
                    {cart.map((item) => {
                      return (
                        <Col key={item.item} style={{ textAlign: "center" }}>
                          <Button
                            className="red-hover"
                            onClick={() => removeFromCart(item)}
                            style={{ margin: "5px" }}
                            variant="secondary"
                          >
                            <img
                              key={item.item}
                              style={{ width: "128px", height: "128px" }}
                              src={item.image}
                            />
                          </Button>
                        </Col>
                      );
                    })}
                  </Row>
                  <div style={{ fontSize: "24px", marginTop: "20px" }}>
                    Note: You can press on items in your cart to remove them.
                  </div>
                </div>
                <Row style={{ borderTop: "1px solid #ccc", paddingTop: "20px" }}>
                  <div style={{ textAlign: "center", fontSize: "24px" }}>
                    When you are ready to checkout, press the Checkout button
                    below!
                  </div>
                  <Button
                    onClick={() => checkOut()}
                    style={{
                      width: "400px",
                      height: "150px",
                      fontSize: "30px",
                      fontWeight: "bold",
                      marginLeft: "auto",
                      marginRight: "auto",
                      marginTop: "20px",
                    }}
                  >
                    Checkout
                  </Button>
                </Row>
              </Row>
            </>
          )}
        </Card.Body>
      </Card>
    </>
  );
}

export default ShoppingList;
